<div class="navigation-search-component-container cc-navigation-search-component-container">
    <dx-text-box
        placeholder="Search Navigation"
        class="text-input"
        [stylingMode]="'underlined'"
        [showClearButton]="true"
        [(value)]="searchText"
        (onValueChanged)="onTextValueChanged($event)"
        (onEnterKey)="onEnterKey($event)"
    >
        <dxi-button name="searchAfter" location="after" [options]="searchButton"></dxi-button>
        <dxi-button name="clear" location="after"></dxi-button>
    </dx-text-box>
</div>
